angular.module("ainapp")
    .controller("productWiseProSalesReportController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService", "$window",
                function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService, $window) {

            $scope.PageName = "Product Wise Proforma Sales Report";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.Branches = [];
            MainService.BranchesInDropdown().then(function (response) {
                var temp = {
                    Id: "",
                    Name: "All",
                }
                $scope.Branches = response.data;
                $scope.Branches.push(temp);
            }, function (err) {
                toastr.error("Network Error");
            })

            $scope.IsSales = true;
            $scope.Employees = [];
            MainService.EmployeesInDropdown().then(function (response) {
                var temp = {
                    Id: "",
                    Name: "All",
                }
                $scope.Employees = response.data;
                $scope.Employees.push(temp);
            }, function (err) {
                toastr.error("Network Error");
            })


            $scope.initDetailReport = function () {

                $scope.ColumnDetails = [
                    {
                        field: "ProSalesInvoice.VoucherNumber",
                        title: "Doc No #",
                        width: "120px",
                            },
                    {
                        field: "Date",
                        title: "Doc Date",
                        template: "#= kendo.toString(kendo.parseDate(Date, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                        width: "120px",


                            },
                    {
                        field: "ProSalesInvoice.Customer.Name",
                        title: "Customer",
                        headerTemplate: $scope.LanguageData.Customer,
                        width: "220px",

                            },

                    {
                        field: "Product.ProductCode",
                        title: "Code",
                        width: "120px",

                                                },

                    {
                        field: "Product.Name",
                        title: "Product",
                        width: "200px",

                                                },

                    {
                        field: "Unit.Name",
                        title: "UOM",
                        width: "100px",

                                                },


                    {
                        field: "Quantity",
                        title: "Qty",
                        width: "100px",
                        aggregates: ["sum"],
                        // footerTemplate: "#=sum#",
                        template: "<div style='text-align: right'>#=kendo.toString(Quantity, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        headerTemplate: kendo.template("<div class='headerright'>Quantity</div>"),
                        groupFooterTemplate: "#=sum#",
                        groupFooterTemplate: "#=kendo.toString(sum, 'n')#",
                            },
                    {
                        field: "UnitPrice",
                        title: "Unit Price",
                        width: "110px",
                        template: "<div style='text-align: right'>#=kendo.toString(UnitPrice, 'n')#</div>",
                        headerTemplate: kendo.template("<div class='headerright'>Unit Price</div>")

                            },
//                    {
//                        field: "Cost",
//                        title: "Cost",
//                        width: "120px",
//                        aggregates: ["sum"],
//                        template: "<div style='text-align: right'>#=kendo.toString(Cost, 'n')#</div>",
//                        footerTemplate: "#=kendo.toString(sum, 'n')#",
//                        headerTemplate: kendo.template("<div class='headerright'>Cost</div>")
//                            },
//                    {
//                        field: "TCost",
//                        title: "TCost",
//                        width: "120px",
//                        aggregates: ["sum"],
//                        template: "<div style='text-align: right'>#=kendo.toString(TCost, 'n')#</div>",
//                        footerTemplate: "#=kendo.toString(sum, 'n')#",
//                        headerTemplate: kendo.template("<div class='headerright'>T Cost</div>")
//                            },

                    {
                        field: "Total",
                        title: "Gross",
                        width: "120px",
                        aggregates: ["sum"],
                        // footerTemplate: "#=sum#",
                        template: "<div style='text-align: right'>#=kendo.toString(Total, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        headerTemplate: kendo.template("<div class='headerright'>Gross</div>"),
                        groupFooterTemplate: "#=sum#",
                        groupFooterTemplate: "#=kendo.toString(sum, 'n')#",
                            },
//                    {
//                        field: "Profit",
//                        title: "Profit",
//                        width: "120px",
//                        aggregates: ["sum"],
//                        // footerTemplate: "#=sum#",
//                        template: "<div style='text-align: right'>#=kendo.toString(Profit, 'n')#</div>",
//                        footerTemplate: "#=kendo.toString(sum, 'n')#",
//                        headerTemplate: kendo.template("<div class='headerright'>Profit</div>")
//                            },
//                    {
//                        field: "ProfitPer",
//                        title: "Profit %",
//                        width: "120px",
//                        aggregates: ["sum"],
//                        // footerTemplate: "#=sum#",
//                        template: "<div style='text-align: right'>#=kendo.toString(ProfitPer, 'n')#</div>",
//                        footerTemplate: "#=kendo.toString(sum, 'n')#",
//                        headerTemplate: kendo.template("<div class='headerright'>Profit %</div>")
//                            },

                    {
                        field: "Discount",
                        title: "Discount",
                        width: "120px",
                        aggregates: ["sum"],
                        // footerTemplate: "#=sum#",
                        template: "<div style='text-align: right'>#=kendo.toString(Discount, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        headerTemplate: kendo.template("<div class='headerright'>Discount</div>"),
                        groupFooterTemplate: "#=sum#",
                        groupFooterTemplate: "#=kendo.toString(sum, 'n')#",
                            },

                    {
                        field: "TaxableAmount",
                        title: "Taxable Amount",
                        width: "160px",
                        aggregates: ["sum"],
                        // footerTemplate: "#=sum#",
                        template: "<div style='text-align: right'>#=kendo.toString(TaxableAmount, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        headerTemplate: kendo.template("<div class='headerright'>Taxable Amount</div>"),
                        groupFooterTemplate: "#=sum#",
                        groupFooterTemplate: "#=kendo.toString(sum, 'n')#",
                            },

                    {
                        field: "RoundOfVat",
                        title: "VAT Amount",
                        width: "150px",
                        aggregates: ["sum"],
                        // footerTemplate: "#=sum#",
                        template: "<div style='text-align: right'>#=kendo.toString(RoundOfVat, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        headerTemplate: kendo.template("<div class='headerright'>VAT Amount</div>"),
                        groupFooterTemplate: "#=sum#",
                        groupFooterTemplate: "#=kendo.toString(sum, 'n')#",
                            },

                    {
                        field: "InventoryValue",
                        title: "Inventory Value",
                        width: "160px",
                        aggregates: ["sum"],
                        // footerTemplate: "#=sum#",
                        template: "<div style='text-align: right'>#=kendo.toString(InventoryValue, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        headerTemplate: kendo.template("<div class='headerright'>Inventory Value</div>"),
                        groupFooterTemplate: "#=sum#",
                        groupFooterTemplate: "#=kendo.toString(sum, 'n')#",
                            },



                        ];


                $scope.CostCenters = [];
                MainService.CostCentersInReortVoucher("Porfoma Invoice").then(function (response) {
                    $scope.CostCenters = response.data;

                    angular.forEach($scope.CostCenters, function (e) {
                        var field = e.CostCenter.Name.replace(/ /g, '');
                        field = field.replace('&', '');
                        field = field.replace('/', '');
                        field = field.replace('.', '');

                        var clm = {
                            title: e.CostCenter.Name,
                            field: "CC" + field,
                            //  template: "<a ng-repeat='cc in dataItem.ProSalesInvoiceCosts' ng-click='temp(dataItem, $event)' >{{cc.CostCenterName}}  </a>",
                            width: '100px',
                            //ng-if='cc.ParentId == $scope.CostCenters[i].CostCenterId'
                        }
                        $scope.ColumnDetails.push(clm);
                    })

                    var options = {
                        title: "Options",
                        headerTemplate: "{{LanguageData.Options}}  ",
                        template: "<button class=' btn-default btn-sm fa fa-pencil' ng-click='Edit(dataItem)'> </button> <button class=' btn-default btn-sm fa fa-eye'  ng-click='View(dataItem)'></button> <button class=' btn-default btn-sm fa fa-print'  ng-click='PrintInvoice(dataItem.ProSalesInvoice.Id, \"Porfoma Invoice\", dataItem.ProSalesInvoice.VoucherNumber)'></button>",
                        width: '100px',
                        sticky: true
                    };

                    $scope.ColumnDetails.push(options);

                    $scope.loadKendoDetailed();
                });

            }

            $scope.initSummaryReport = function () {

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });

                $scope.CostCenters = [];
                MainService.CostCentersInReortVoucher("Proforma Invoice").then(function (response) {
                    $scope.CostCenters = response.data;
                })

                $scope.CurrentReportConfig = {};
                $scope.selectedItems = [];
                $scope.summaryColumns = [];
                MainService.ReportConfigsbyType("Proforma Invoice", "Report").then(function (response3) {
                    if (response3.data != null && response3.data != "") {
                        $scope.CurrentReportConfig = response3.data;
                        var array = JSON.parse($scope.CurrentReportConfig.TableArray);
                        $scope.selectedItems = array;

                        $scope.summaryColumns = angular.copy(array);

                        angular.forEach($scope.summaryColumns, function (e) {
                            e.width = '100px';
                        })

                        var options = {
                            title: "Options",
                            headerTemplate: "{{LanguageData.Options}}  ",
                            template: "<button class=' btn-default btn-sm fa fa-pencil' ng-click='Edit(dataItem)'> </button> <button class=' btn-default btn-sm fa fa-eye'  ng-click='View(dataItem)'></button> <button class=' btn-default btn-sm fa fa-print'  ng-click='PrintInvoice(dataItem.Id, \"Porfoma Invoice\", dataItem.VoucherNumber)'></button>",
                            width: '100px',
                            sticky: true
                        };

                        $scope.summaryColumns.push(options);

                        $scope.loadKendoSummary();
                        //                        $scope.setCostCenterCols(function () {
                        //                            $scope.loadKendoSummary();
                        //                        })
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $.LoadingOverlay("hide");
                })


            }


            $scope.Init = function () {

                $('#filterModal').modal('show');
                var startdate = new Date(new Date().getFullYear(), 0, 1);


                $scope.filter = {
                    CustomerName: "",
                    BranchId: "",
                    ProductName: "",
                    VoucherNo: "",
                    CustomerId: "",
                    FromDate: startdate,
                    ToDate: new Date(),
                    CustomerIds: [],
                    ProductIds: [],
                }

                $scope.load = false;
                $scope.isFilter = false;

                $scope.ReportType = $stateParams.Type;
                if ($scope.ReportType == "Detail") {
                    $scope.ReportName = "Detail";
                    $scope.initDetailReport();
                } else if ($scope.ReportType == "PendingDetail") {
                    $scope.ReportName = "Detail (Pending)";
                    $scope.IsPending = true;
                    $scope.initDetailReport();
                } else if ($scope.ReportType == "PendingSummary") {
                    $scope.ReportName = "Summary (Pending)";
                    $scope.IsPending = true;
                    $scope.initSummaryReport();
                } else {
                    $scope.ReportName = "Summary";
                    $scope.initSummaryReport();
                }

            }
            $scope.Init();

            $scope.temp = function (data, temp) {
                console.log(data);
                console.log(temp);
            }

            $scope.customerSelectDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter != undefined) {
                            if (o.data.filter.filters.length > 0) {
                                MainService.CustomerInAutoComplete(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success({
                                        Data: []
                                    });
                                    toastr.error("Network Error");
                                });
                            } else {
                                o.success({
                                    Data: []
                                });
                            }
                        } else {
                            o.success({
                                Data: []
                            });
                        }

                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 10
            };

            $scope.selectCustomerOptions = {
                placeholder: "Select Accounts...",
                dataTextField: "Name",
                dataValueField: "Id",
                valuePrimitive: true,
                filter: "contains",
                autoBind: true,
                dataSource: $scope.customerSelectDataSource
            };


            $scope.productSelectDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter != undefined) {
                            if (o.data.filter.filters.length > 0) {
                                MainService.productInAutoComplete(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success({
                                        Data: []
                                    });
                                    toastr.error("Network Error");
                                });
                            } else {
                                o.success({
                                    Data: []
                                });
                            }
                        } else {
                            o.success({
                                Data: []
                            });
                        }

                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 10
            };

            $scope.selectProductOptions = {
                placeholder: "Select Products...",
                dataTextField: "Name",
                dataValueField: "Id",
                valuePrimitive: true,
                autoBind: true,
                dataSource: $scope.productSelectDataSource
            };




            $scope.loadKendoDetailed = function () {

                $scope.KendoSource = new kendo.data.DataSource({
                    batch: true,
                    transport: {
                        read: function (o) {


                            if ($scope.isFilter) {

                                o.data.FromDateString = $scope.extractDate($scope.filter.FromDate);
                                o.data.ToDateString = $scope.extractDate($scope.filter.ToDate);

                                o.data.CustomerId = $scope.filter.CustomerId;
                                o.data.VoucherNo = $scope.filter.VoucherNo;
                                o.data.ProductId = $scope.filter.ProductId;

                                o.data.CustomerIds = $scope.filter.CustomerIds;
                                o.data.ProductIds = $scope.filter.ProductIds;
                                o.data.BranchId = $scope.filter.BranchId;
                                o.data.CostCenters = $scope.CostCenters;
                                o.data.IsPending = $scope.IsPending;
                                o.data.EmployeeId = $scope.filter.EmployeeId;

                                MainService.PorSalesInvoiceDetailedReport(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success({
                                        Data: []
                                    });
                                    toastr.error("NetworkError");
                                })
                            } else {
                                o.success({
                                    Data: []
                                });
                            }


                        },

                    },
                    change: function (data) {
                        if (data.items.length > 0) {
                            console.log(data);
                            var arr = [];
                            angular.forEach($scope.CostCenters, function (e) {
                                var field = e.CostCenter.Name.replace(/ /g, '');
                                field = field.replace('&', '');
                                field = field.replace('/', '');
                                field = field.replace('.', '');
                                arr.push('CC' + field);
                            })
                            angular.forEach(data.items, function (e) {
                                angular.forEach(arr, function (ar) {

                                    angular.forEach(e.ProSalesInvoiceCosts, function (a) {

                                        var afield = a.ParentName.replace(/ /g, '');
                                        afield = afield.replace('&', '');
                                        afield = afield.replace('/', '');
                                        afield = afield.replace('.', '');
                                        afield = "CC" + afield;

                                        if (afield == ar) {
                                            e[ar] = a.CostCenterName;
                                        }
                                    })


                                })
                            })
                        }
                    },
                    schema: {
                        data: "Data",
                        total: "Total",
                        model: {
                            id: "Id",
                            fields: {
                                "ProSalesInvoice.VoucherNumber": {
                                    type: "string",
                                    editable: false,
                                },
                                "Date": {
                                    type: "date",
                                    editable: false,
                                },
                                "Product.ProductCode": {
                                    type: "string",
                                    editable: false,
                                },
                                "Product.Name": {
                                    type: "string",
                                    editable: false,
                                },
                                //                            "Product.Description": {
                                //                                type: "string",
                                //                                editable: false,
                                //                            },
                                "Unit.Name": {
                                    type: "string",
                                    editable: false,
                                },
                                Quantity: {
                                    type: "number",
                                    editable: false,
                                },
                                "ProSalesInvoice.Customer.Name": {
                                    type: "string",
                                    editable: false,
                                },

                                UnitPrice: {
                                    type: "number",
                                    editable: false,
                                },
                                Total: {
                                    type: "number",
                                    editable: false,
                                },

                                Discount: {
                                    type: "number",
                                    editable: false,
                                },
                                //                                Cost: {
                                //                                    type: "number",
                                //                                    editable: false,
                                //                                },
                                //                                TCost: {
                                //                                    type: "number",
                                //                                    editable: false,
                                //                                },
                                //                                Profit: {
                                //                                    type: "number",
                                //                                    editable: false,
                                //                                },


                                TaxableAmount: {
                                    type: "number",
                                    editable: false,
                                },
                                RoundOfVat: {
                                    type: "number",
                                    editable: false,
                                },
                                InventoryValue: {
                                    type: "number",
                                    editable: false,
                                },
                                //                                ProfitPer: {
                                //                                    type: "number",
                                //                                    editable: false,
                                //                                },

                            }
                        }
                    },
                    serverPaging: true,
                    serverSorting: true,
                    serverFiltering: true,
                    pageSize: 20,

                    group: [{
                        field: "Product.Name",
                        aggregates: [{
                                field: "Quantity",
                                aggregate: "sum"
                    },
//                            {
//                                field: "Cost",
//                                aggregate: "sum"
//                        },
//                            {
//                                field: "TCost",
//                                aggregate: "sum"
//                        },
//                            {
//                                field: "Profit",
//                                aggregate: "sum"
//                        },
                            {
                                field: "Total",
                                aggregate: "sum"
                        }, {
                                field: "Discount",
                                aggregate: "sum"
                        },
                            {
                                field: "TaxableAmount",
                                aggregate: "sum"
                        },
                            {
                                field: "RoundOfVat",
                                aggregate: "sum"
                        },
                            {
                                field: "InventoryValue",
                                aggregate: "sum"
                        }]
                    }],
                    aggregate: [
                        {
                            field: "Quantity",
                            aggregate: "sum"
                        },
//                        {
//                            field: "Cost",
//                            aggregate: "sum"
//                            },
//                        {
//                            field: "TCost",
//                            aggregate: "sum"
//                            },
                        {
                            field: "Total",
                            aggregate: "sum"
                            },
//                        {
//                            field: "Profit",
//                            aggregate: "sum"
//                            },
                        {
                            field: "Discount",
                            aggregate: "sum"
                            },
                        {
                            field: "TaxableAmount",
                            aggregate: "sum"
                            },
                        {
                            field: "RoundOfVat",
                            aggregate: "sum"
                            },
                        {
                            field: "InventoryValue",
                            aggregate: "sum"
                            }
//                        {
//                            field: "ProfitPer",
//                            aggregate: "sum"
//                            }
                    ],
                });

                $scope.KendoGridOptions = {
                    editable: false,
                    pageable: true,
                    toolbar: ["excel"],
                    height: 700,
                    resizable: true,
                    dataSource: $scope.KendoSource,
                    pageSize: 20,
                    pageable: {
                        input: false,
                        refresh: true,
                        pageSizes: true,
                        info: true,
                    },
                    sortable: true,
                    scrollable: true,
                    filterable: true,
                    groupable: true,
                    columnMenu: {
                        filterable: false,
                        filterable: true,
                    },

                    columns: $scope.ColumnDetails,
                };

            }

            $scope.loadKendoSummary = function () {

                $scope.KendoSource2 = new kendo.data.DataSource({
                    batch: true,
                    transport: {
                        read: function (o) {

                            if ($scope.isFilter) {

                                o.data.selectedFields = [];
                                angular.forEach($scope.selectedItems, function (e) {
                                    o.data.selectedFields.push(e.field);
                                })

                                o.data.FromDateString = $scope.extractDate($scope.filter.FromDate);
                                o.data.ToDateString = $scope.extractDate($scope.filter.ToDate);

                                o.data.CustomerId = $scope.filter.CustomerId;
                                o.data.VoucherNo = $scope.filter.VoucherNo;
                                o.data.ProductId = $scope.filter.ProductId;
                                o.data.BranchId = $scope.filter.BranchId;

                                o.data.CustomerIds = $scope.filter.CustomerIds;
                                o.data.ProductIds = $scope.filter.ProductIds;
                                o.data.CostCenters = $scope.CostCenters;
                                o.data.IsPending = $scope.IsPending;
                                o.data.EmployeeId = $scope.filter.EmployeeId;


                                MainService.ProSalesInvoiceDynamicSummaryReport(o.data).then(function (response) {
                                    if (response.data != null) {
                                        o.success(response.data);
                                    } else {
                                        o.success({
                                            Data: []
                                        });
                                    }
                                }, function (err) {
                                    o.success({
                                        Data: []
                                    });
                                    toastr.error("Network Error");
                                })
                            } else {
                                o.success({
                                    Data: []
                                });
                            }


                        },

                    },
                    change: function (data) {
                        if (data.items.length > 0) {
                            console.log(data);

                            angular.forEach(data.items, function (e) {
                                angular.forEach($scope.selectedItems, function (ar) {

                                    angular.forEach(e.ProSalesInvoiceCosts, function (a) {

                                        var afield = a.ParentName.replace(/ /g, '');
                                        afield = afield.replace('&', '');
                                        afield = afield.replace('/', '');
                                        afield = afield.replace('.', '');
                                        afield = "CC" + afield;

                                        if (afield == ar.field) {
                                            e[ar.field] = a.CostCenterName;
                                        }
                                    })


                                })
                            })
                        }
                    },
                    schema: {
                        data: "Data",
                        total: "Total",
                        model: {
                            id: "Id",
                        }
                    },
                    serverPaging: true,
                    serverSorting: true,
                    serverFiltering: true,
                    pageSize: 20,
                    aggregate: [{
                            field: "GrossTotal",
                            aggregate: "sum"
                },
                        {
                            field: "NetTotal",
                            aggregate: "sum"
                    }, {
                            field: "TotalDiscount",
                            aggregate: "sum"
                    }, {
                            field: "TotalQuantity",
                            aggregate: "sum"
                    },
                        {
                            field: "TotalOtherCharges",
                            aggregate: "sum"
                    },
                        {
                            field: "TotalExtraCharges",
                            aggregate: "sum"
                    },
                        {
                            field: "TotalTax",
                            aggregate: "sum"
                    }, {
                            field: "GrandTotal",
                            aggregate: "sum"
                    },
                        {
                            field: "CalcGrandTotal",
                            aggregate: "sum"
                        }, {
                            field: "TotalCost",
                            aggregate: "sum"
                        }],
                });

                $scope.KendoGridOptions2 = {

                    editable: false,
                    pageable: true,
                    toolbar: ["excel"],
                    height: 600,
                    width: "100%",
                    resizable: true,
                    dataSource: $scope.KendoSource2,
                    pageSize: 20,
                    pageable: {
                        input: false,
                        refresh: true,
                        pageSizes: true,
                        info: true,
                    },
                    sortable: true,
                    scrollable: {
                        horizontal: true
                    },
                    filterable: true,
                    groupable: true,
                    columnMenu: {
                        filterable: false,
                        filterable: true,
                    },

                    columns: $scope.summaryColumns,
                };


            }


            $scope.Edit = function (data) {
                if ($scope.ReportType == "Detail") {
                    $state.go("editPorSalesInvoice", {
                        VoucherId: data.ProSalesInvoice.Id
                    })
                } else {
                    $state.go("editPorSalesInvoice", {
                        VoucherId: data.Id
                    })
                }
            }

            $scope.View = function (data) {
                if ($scope.ReportType == "Detail") {
                    $state.go("viewPorSalesInvoice", {
                        VoucherId: data.ProSalesInvoice.Id
                    })
                } else {
                    $state.go("viewPorSalesInvoice", {
                        VoucherId: data.Id
                    })
                }
            }

            $scope.OpenFilter = function () {
                $('#filterModal').modal('show');
            }

            $scope.GetReport = function () {
                $scope.isFilter = true;
                $('#filterModal').modal('hide');
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }

            $scope.Refresh = function () {
                $scope.Init();
                $scope.isFilter = true;
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }

            $scope.print = function () {

                $scope.filter.FromDateString = $scope.extractDate($scope.filter.FromDate);
                $scope.filter.ToDateString = $scope.extractDate($scope.filter.ToDate);

                $scope.filter.CostCenters = $scope.CostCenters;

                if ($scope.ReportType == "Detail") {

                    MainService.PrintProformaInvoiceReport($scope.filter).then(function (response) {
                        if (response.data != null) {
                            $window.open(config.basePath + "/Reports/" + response.data, "_blank");
                        } else {
                            toastr.error("Network Error");
                        }
                        $scope.Load = false;
                    }, function (err) {
                        toastr.error("Network Error");
                        $scope.Load = false;
                    })

                } else {

                    MainService.PrintProformaInvoiceSummaryReport($scope.filter).then(function (response) {
                        if (response.data != null) {
                            $window.open(config.basePath + "/Reports/" + response.data, "_blank");
                        } else {
                            toastr.error("Network Error");
                        }
                        $scope.Load = false;
                    }, function (err) {
                        toastr.error("Network Error");
                        $scope.Load = false;
                    })

                }



            }


        }])
